import {
  localNum,
  useStrictLocalization,
} from "@faire/web/common/localization";

import { BYTES_IN_MB, DropError, FileRejectionCode } from "./const";

interface IUseFileUploadErrorMessages {
  maxSize: number;
}

export const useFileUploadErrorMessages = ({
  maxSize,
}: IUseFileUploadErrorMessages) => {
  const { strictLocalize } = useStrictLocalization();

  const localizedErrorMessage = (error?: DropError) => {
    switch (error) {
      case FileRejectionCode.FILE_TOO_LARGE:
        return strictLocalize(
          {
            defaultMessage:
              "File is too large. Max size is {maxFileSizeNumberWithUnit} MB.",
            description: {
              text: "Error message when file is too large to upload",
            },
          },
          { maxFileSizeNumberWithUnit: localNum(maxSize / BYTES_IN_MB) }
        );
      case FileRejectionCode.FILE_INVALID_TYPE:
        return strictLocalize({
          defaultMessage: "File type is not supported.",
          description: {
            text: "Error message when file type is not supported for an attempted file upload",
          },
        });
      case FileRejectionCode.NETWORK_ERROR:
        return strictLocalize({
          defaultMessage: "Network error. Please try again.",
          description: {
            text: "Error message when file upload fails due to a network error",
          },
        });
      case FileRejectionCode.FILE_TOO_SMALL:
      default:
        return strictLocalize({
          defaultMessage: "File upload failed.",
          description: {
            text: "Error message when file upload fails for an unknown reason",
          },
        });
    }
  };

  return localizedErrorMessage;
};
